import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

// Support / production users only ever see the onboarding pipeline + their profile.
export const SUPPORT_ALLOWED = [/^\/onboarding(\/|$)/, /^\/tasks(\/|$)/, /^\/settings(\/|$)/, /^\/profile(\/|$)/, /^\/notifications(\/|$)/];
export const isSupportRole = (user) => user?.role === "support";

export default function ProtectedRoute({ children }) {
  const { user, ready } = useAuth();
  const loc = useLocation();
  if (!ready)
    return (
      <div className="min-h-screen grid place-items-center bg-[#F8F9FA]">
        <div className="text-sm text-[#6C757D]">Loading…</div>
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  if (isSupportRole(user) && !SUPPORT_ALLOWED.some((re) => re.test(loc.pathname))) {
    return <Navigate to="/onboarding" replace />;
  }
  return children;
}
